export default async function loadGNB() {
  let gnbLib;
  if (Ridi.globals.isMobile) {
    gnbLib = await import(/* webpackChunkName: "gnb.m" */ './gnb.lib.m');
  } else if (Ridi.globals.isPaper) {
    gnbLib = await import(/* webpackChunkName: "gnb.e" */ './gnb.lib.e');
  } else {
    gnbLib = await import(/* webpackChunkName: "gnb" */ './gnb.lib');
  }
  return gnbLib.default;
}



// WEBPACK FOOTER //
// ./common/gnb.wrapper.js